import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundButton from 'Components/UI/RoundButton';

import { useFlowContext } from './FlowContext';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  previousButton: {
    marginTop: theme.spacing(2),
  },
});

const FlowProgress = ({
  className,
  classes,
}) => {
  const {
    completeFlow,
    isFirstStep,
    isLastStep,
    navigateToNextStep,
    navigateToPreviousStep,
  } = useFlowContext();

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <RoundButton
        color="secondary"
        disableElevation
        onClick={(isLastStep) ? completeFlow : navigateToNextStep}
        variant="contained"
      >
        {(isLastStep) ? 'Complete' : 'Continue'}
      </RoundButton>
      {!isFirstStep && (
        <RoundButton
          className={classes.previousButton}
          color="white"
          onClick={navigateToPreviousStep}
          variant="text"
        >
          {'Previous'}
        </RoundButton>)
      }
    </div>
  );
};

FlowProgress.defaultProps = {
  className: '',
};

FlowProgress.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FlowProgress);
